/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import CloseAction from './CloseAction/index'
import CommsThread from 'DesignSystem/CommsThread/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/FilesEdit/Content/Comms/Content"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let selectedThreadIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'thread_id',
})
let selectedIsSecureValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'is_secure',
})
let selectedAutoUploadedAttachmentsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'auto_uploaded_attachments',
})
let selectedMessageValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'message',
})
let selectedTagsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'tags',
})
let constantData = 'Please find the attachments included for'
let patientPersonValueData = fromData.useDataFormat({ viewPath,
context: 'patient',
path: 'person',
format: fromFormat.patientName,
})
let aggregateData = fromAggregate.join(constantData, patientPersonValueData)
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: '_id',
})
let onSubmit = fromHelpers.useOnSubmit({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 paddingBottom={dtSpaceM}
 paddingLeft={0}
 paddingRight={0}
 dangerouslyBypassFocusLock={true}
 maxHeight="95%"
 width={500}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 color={dtColorsNeutral900}
 marginBottom={dtSpaceS}
 text="Edit letter"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<CommsThread
{...childProps}
  viewPath={`${viewPath}/CommsThread`}
 data="selected.thread_id"
 thread_id={selectedThreadIdValueData}
 data="selected.is_secure"
 is_secure={selectedIsSecureValueData}
 data="selected.auto_uploaded_attachments"
 auto_uploaded_attachments={selectedAutoUploadedAttachmentsValueData}
 data="selected.message"
 message={selectedMessageValueData}
 data="selected.tags"
 tags={selectedTagsValueData}
 data="'Please find the attachments included for'"
 data="patient.person"
 format="/Data/format.js patientName"
 aggregate="/Simple/Data/aggregate.js join"
 attachments_message={aggregateData}
 data="patient._id"
 patient_id={patientIdValueData}
 data="selected"
 onSubmit={onSubmit}
/>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}